var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',_vm._l((_vm.keyResults),function(keyResult){return _c('b-list-group-item',{key:keyResult.id,staticClass:"p-2"},[_vm._t("default",null,{"keyResult":keyResult})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }